module.exports = __webpack_public_path__ + "static/img/qudi (12).0c457e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qudi/qudi (12).jpg
// module id = GAh7
// module chunks = 0